/**
 * Parse CSV text into an array of row objects keyed by header names.
 * @param {string} str
 * @param {string} [delimiter=","]
 * @returns {Record<string, string>[]}
 */
export const csvToArray = (str, delimiter = ",") => {
  if (!str || typeof str !== "string") {
    return [];
  }

  const headerLine = str.slice(0, str.indexOf("\n"));
  if (!headerLine) {
    return [];
  }

  const headers = headerLine.split(delimiter);
  const rows = str.slice(str.indexOf("\n") + 1).split("\n");

  if (rows?.length > 0 && rows[rows.length - 1] === "") {
    rows.splice(-1);
  }

  if (!rows || rows.length === 0) {
    return [];
  }

  return rows.map((row) => {
    const values = row.split(delimiter);
    return headers.reduce((object, header, index) => {
      object[header.trim()] = values[index]?.trim() ?? "";
      return object;
    }, {});
  });
};

/**
 * Read a CSV file and return the first column values (user IDs / mobile numbers).
 * @param {File} file
 * @returns {Promise<string[]>}
 */
export const parseCsvFirstColumn = (file) =>
  new Promise((resolve, reject) => {
    if (!file) {
      resolve([]);
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const textData = event.target?.result;
        const rows = csvToArray(textData);

        if (!rows.length) {
          resolve([]);
          return;
        }

        const values = rows
          .map((row) => Object.values(row)[0]?.replace(/(\r\n|\n|\r)/gm, "") ?? "")
          .filter(Boolean);

        resolve(values);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => reject(new Error("Failed to read CSV file"));
    reader.readAsText(file);
  });
